<template>
  <f7-page>
    <f7-navbar :title="$t('title.help')" :back-link="$t('action.back')"/>
    <f7-card :title="$t('title.guides')">
      <f7-card-content>
        <f7-button fill large @click='openFAQ'>{{$t('action.faq')}}</f7-button>
        <br/>
        <f7-button fill large @click='openVideos'>{{$t('action.videoTutorials')}}</f7-button>
      </f7-card-content>
    </f7-card>
    <f7-card :title="$t('title.reportIssue')">
      <f7-card-content>
        <f7-list inline-labels no-hairlines-md>
          <f7-list-input :label="$t('label.subject')"
                         required
                         :validate="!sent"
                         type="select"
                         :value="reportSubject"
                         @input="reportSubject = $event.target.value"
          >
            <option>{{$t('option.technicalIssue')}}</option>
            <option>{{$t('option.stylingIssue')}}</option>
            <option>{{$t('option.generalSuggestion')}}</option>
            <option>{{$t('option.cardIssue')}}</option>
            <option>{{$t('option.other')}}</option>
          </f7-list-input>
          <f7-list-input required :validate="!sent" type="textarea" :placeholder="$t('label.description')"
                         :value="reportDescription" @input="reportDescription = $event.target.value"
          />
          <f7-list-item v-if="error">
            <f7-card class="text-color-white bg-color-red">
              <f7-card-content>
                {{$t('dialog.supportError', { error })}}
              </f7-card-content>
            </f7-card>
          </f7-list-item>
          <f7-list-item>
            <f7-button fill large @click="reportIssue" :disabled="!(reportSubject && reportDescription)">
              {{$t('action.submitRequest')}}
              <f7-icon f7="checkmark" v-if="sent"/>
            </f7-button>
          </f7-list-item>
        </f7-list>
      </f7-card-content>
    </f7-card>
  </f7-page>
</template>

<script>
  import cordovaHelpers from '@/utils/cordova-helpers'
  import helpers from '@/utils/helpers'
  import Slack from 'slack'

  let token = 'xoxp-15670294581-148701868755-463108297092-60a0a1615ab15898a8fdbab806fb0215'
  // let bugChannel = 'C0FU789JP'
  let bot = new Slack(token)

  export default {
    data () {
      return {
        reportSubject: '',
        reportDescription: '',
        sent: false,
        error: null,
      }
    },
    watch: {
      reportSubject (value) {
        if (value) this.sent = false
      },
      reportDescription (value) {
        if (value) this.sent = false
      },
    },
    methods: {
      openFAQ () {
        window.open('https://getaio.co.uk/faq/', this.hrefTarget)
      },
      openVideos () {
        window.open('https://getaio.co.uk/videos/', this.hrefTarget)
      },
      async reportIssue () {
        this.sent = false
        let channel = process.env.VUE_APP_SLACK_SUPPORT_CHANNEL
        let username = this.currentUser.firstName + ' ' + this.currentUser.lastName

        let reportAttachment = {
          title: 'New customer support request',
          color: '#f49b01',
          fields: [
            { title: 'Subject', short: true, value: this.reportSubject },
            { title: 'Message', value: this.reportDescription },
          ],
        }

        let userInfo = {
          title: 'User Info',
          color: 'good',
          fields: [
            { title: 'Name', value: username },
            { title: 'E-mail', short: true, value: this.currentUser.email },
            { title: 'Phone Number', short: true, value: this.currentUser.phone },
            { title: 'Manager', value: this.currentUser.isManager ? 'yes' : 'no' },
          ],
        }

        let deviceInfo = {
          title: 'Device Info',
          color: '#439FE0',
          fields: [
            { title: 'Browser Version', value: navigator.appVersion },
            { title: 'Cookies Enabled', short: true, value: navigator.cookieEnabled ? 'yes' : 'no' },
            { title: 'Browser Language', short: true, value: navigator.language },
            { title: 'Browser Online', short: true, value: navigator.onLine ? 'yes' : 'no' },
            { title: 'Platform', short: true, value: navigator.platform },
            { title: 'User-agent', value: navigator.userAgent },
          ],
        }

        let historyInfo = { title: 'History', color: '#696969' }
        historyInfo.text = this.$f7.views.main.router.history.join('\n')

        let attachments = JSON.stringify([reportAttachment, userInfo, deviceInfo, historyInfo])

        this.$bus.$emit('ajax-start')
        try {
          await bot.chat.postMessage({ token, channel, text: '', attachments, username, as_user: false })
          this.$bus.$emit('ajax-stop')
          this.reportSubject = ''
          this.reportDescription = ''
          this.sent = true
        } catch (err) {
          this.$bus.$emit('ajax-stop')
          console.error(err)
          this.error = err.message
        }
      },
    },
    mixins: [cordovaHelpers, helpers],
  }
</script>
